import React from 'react';
import PropTypes from 'prop-types';
import { testAttributes } from './Constants';
import * as Classes from './InfoBox.module.scss';

const BoxIconComponent = ({ boxIcon, title }) =>
{
    if (typeof boxIcon === 'string')
    {
        return (
            <img
                src={boxIcon}
                alt={title}
                aria-label={title}
                style={{ width: 48, height: 48 }}
                data-testid={testAttributes.INFO_BOX_ICON}
            />
        );
    }
    if (typeof boxIcon === 'object')
    {
        const Icon = boxIcon;
        return (
            <Icon
                role="img"
                aria-label={title}
                sx={{ width: 48, height: 48, color: "#13496d" }}
                data-testid={testAttributes.INFO_BOX_ICON}
            />
        );
    }
    return null;
};

BoxIconComponent.propTypes = {
    boxIcon: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.element,
        PropTypes.func,
    ]).isRequired,
    title: PropTypes.string.isRequired,
};

const InfoBox = ({ item }) =>
{
    if (!item) return null;

    const { description, boxIcon, title } = item;

    return (
        <div
            className={Classes.infoBoxContainer}
            data-testid={`${testAttributes.INFO_BOX_CONTAINER}-${title.replace(/ /g, '-')}`}
        >
            {boxIcon && (<BoxIconComponent boxIcon={boxIcon} title={title} />)}
            <div className={Classes.textContainer} data-testid={testAttributes.INFO_BOX_CONTENT}>
                <h3>{title}</h3>
                <p>{description}</p>
            </div>
        </div>
    );
}

InfoBox.propTypes = {
    item: PropTypes.shape({
        title: PropTypes.string.isRequired,
        description: PropTypes.string.isRequired,
        boxIcon: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.element,
            PropTypes.func,
        ]).isRequired,
    }).isRequired,
};

export default InfoBox;